module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n	<div class="text-block">\n		<h5>The Streak competition begins in Round 5</h5>\n	</div>\n</div>';
}
return __p;
};
